module.exports = __webpack_public_path__ + "img/fm-logo.cc0717d3.png";